/**
 * Pixi visual styling for HITL frames and their openings (doors/windows):
 * stroke/fill colours and alphas, end-stroke hit geometry, and the thicker
 * stroke used to emphasise selected frames.
 */
export const FrameAndOpeningStyle = {
	/** Pink used for frame polygons behind the blue/green openings overlay. */
	openingsModeFrameColor: 0xe3538f,
	/** Alpha applied to frame shapes while the canvas is in openings mode. */
	openingsModeFrameAlpha: 0.35,

	openingStrokeWidth: 2,
	openingStrokeColor: 0xe3538f,
	openingStrokeAlpha: 1,

	openingFillAlpha: 0.18,
	openingHoverFillColor: 0xffffff,
	openingHoverFillAlpha: 1,
	openingDraftFillColor: 0x000000,
	openingDraftFillAlpha: 0,

	windowFillColor: 0x3b82f6,
	windowStrokeColor: 0x3b82f6,
	doorFillColor: 0x22c55e,
	doorStrokeColor: 0x22c55e,

	openingEndStrokeBaseFactor: 1,
	openingEndStrokeSelectedFactor: 1.5,
	endStrokeHitPadding: 6,
	/**
	 * Axial reach (px, world space) each end-stroke resize handle extends
	 * *outward* past its endpoint. Biasing the hit target outward — and capping
	 * the inward reach at `endStrokeHitPadding` — keeps the two handles of a small
	 * opening from overlapping, so either end stays independently grabbable
	 * (ROME-7993).
	 */
	endStrokeHitOuterReach: 10,

	openingVisualThickness: 16,

	/**
	 * Hard minimum opening length (px, world space) enforced on an explicit
	 * end-stroke resize — a user may still shrink an opening down to this.
	 */
	minOpeningLength: 5,
	/**
	 * Minimum length (px, world space) a freshly *created* opening is expanded to
	 * (centered, clamped to the available gap) so its two resize handles start far
	 * enough apart to grab comfortably (ROME-7993). Equals
	 * `openingVisualThickness * 1.5`.
	 */
	minCreateOpeningLength: 24,

	/**
	 * Extra reach (px, world space) added around an opening for selection
	 * hit-testing, and the axial buffer within which creating a new opening is
	 * suppressed.
	 */
	openingSelectionHitPadding: 8,

	openingPasteGhostFillAlpha: 0.4,
	/** Pixi label assigned to the alt-copy/paste draft ghost graphics. */
	pasteGhostLabel: 'draft-opening-paste-ghost',

	thickFrameStrokeWidth: 5,
	thickFramePointRadius: 8,
} as const;
